import { KSIPreloadAPIConfig, KSIPreloadAPIRequestConfig } from '@sailor/ksi-tools-preload-request';
import { handlePreviewParams } from '@/src/utils/preview';
import { pageHandleFilterParams, SLPreloadBizSailorCAPP } from '../Utils/index';

const SLLocation = Mach.requireModule('SLLocation');
const SLHomeCore = Mach.requireModule('SLHomeCore');

class SLChannelListRequestConfig extends KSIPreloadAPIRequestConfig {
  url(): string {
    return 'v1/special/common/page';
  }

  body(schemeParams: any): object {
    return this.repuestBody(schemeParams);
  }

  ignore(): boolean {
    const { coreModelStatus } = SLHomeCore?.getCoreInfo?.() || {};
    return coreModelStatus !== 2;
  }

  repuestBody = (schemeParams: any, payload: any = {}, bizTraceId: string = '', isFirstRequest: boolean = true, filterBarModel: any = undefined, selectedScenceTab: any = {}) => {
    const filterPanelData = filterBarModel?.filterBarPanelData;

    const onceData = JSON.parse(schemeParams?.onceData || '{}') || {};
    const firstReqParams = isFirstRequest ? {
      clickId: schemeParams?.clickId,
      previewShops: schemeParams?.previewShops,
      ...onceData,
    } : {};
    const {
      pageNo = 0, options = {}
    } = payload || {};
    // 遍历 schemeParams 并去除一些key
    const schemeParamsKeys = Object.keys(schemeParams || {});
    const everyRequestParams = {};
    schemeParamsKeys.forEach((key) => {
      if (key !== 'onceData' && key !== 'tabKey') {
        everyRequestParams[key] = schemeParams[key];
      }
    });
    // 清空的时候要filterPanelData还没更新，需要传空
    const isOptionsEmpty = Object.keys(options).length === 0;

    const extraMap = {
      ...pageHandleFilterParams(isOptionsEmpty ? {} : filterPanelData),
      tab_key: selectedScenceTab?.tabKey || '-999'
    };
    const location = SLLocation?.getLocation();
    const params = {
      ...everyRequestParams,
      location: {
        latitude: location?.latitude,
        longitude: location?.longitude,
        actualLatitude: location?.actualLatitude,
        actualLongitude: location?.actualLongitude,
      },
      options,
      // pageSource: 1, // 首页-5, 自提-1
      pageSize: 20,
      pageNo,
      bizTraceId: pageNo > 0 ? bizTraceId : '',
      supplyId: selectedScenceTab?.supplyId || schemeParams?.supplyId || '',
      // tab中若没有配置 specialScene，则取 schemeParams 中的 specialScene
      specialScene: selectedScenceTab?.specialScene || schemeParams?.specialScene || '',
      tabId: selectedScenceTab?.tabId || '',
      tabType: selectedScenceTab?.tabType || '',
      extraMap,
      ...firstReqParams,
      mainBundleVersion: Mach.env.bundleVersion,
    };
    handlePreviewParams(params);

    return params;
  };

  handleResponseAvailable(response: any): boolean {
    return response && response.data && response.code === 0;
  }
}

class SLChannelListPrelodAPIConfig extends KSIPreloadAPIConfig {
  requestItem = new SLChannelListRequestConfig()

  bizline(): string {
    return SLPreloadBizSailorCAPP;
  }

  reqRuleVersion(): string {
    return 'v0.0.1';
  }

  bundleName(): string {
    return 'mach_pro_sailor_c_channel_list_main';
  }

  timeoutCallbackDuration(): number {
    return 10000;
  }

  requestItems(): KSIPreloadAPIRequestConfig[] {
    return [this.requestItem];
  }
}

export { SLChannelListPrelodAPIConfig, SLChannelListRequestConfig };
